var React = require('react');

function ExternalUrl (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"","d":"M497.6,0,334.4.17A14.4,14.4,0,0,0,320,14.57V47.88a14.4,14.4,0,0,0,14.69,14.4l73.63-2.72,2.06,2.06L131.52,340.49a12,12,0,0,0,0,17l23,23a12,12,0,0,0,17,0L450.38,101.62l2.06,2.06-2.72,73.63A14.4,14.4,0,0,0,464.12,192h33.31a14.4,14.4,0,0,0,14.4-14.4L512,14.4A14.4,14.4,0,0,0,497.6,0ZM432,288H416a16,16,0,0,0-16,16V458a6,6,0,0,1-6,6H54a6,6,0,0,1-6-6V118a6,6,0,0,1,6-6H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V304A16,16,0,0,0,432,288Z","fill":"currentColor"}));
}

ExternalUrl.defaultProps = {"className":"svg-inline--fa fa-external-link fa-w-16 fa-9x","aria-hidden":"true","data-icon":"external-link","data-prefix":"far","focusable":"false","role":"img","viewBox":"0 0 512 512"};

module.exports = ExternalUrl;

ExternalUrl.default = ExternalUrl;
